// frontend/src/components/AboutSection.jsx
import React from "react";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="relative bg-gray-50 py-20 px-6 sm:px-12 lg:px-20 overflow-hidden"
    >
      {/* Background animated circles */}
      <div className="absolute -top-32 left-0 sm:left-10 w-56 sm:w-80 h-56 sm:h-80 rounded-full bg-gradient-to-tr from-purple-400/30 to-pink-300/20 filter blur-3xl animate-float-slow"></div>
      <div className="absolute -bottom-32 right-0 sm:right-10 w-72 sm:w-96 h-72 sm:h-96 rounded-full bg-gradient-to-tr from-blue-400/20 to-indigo-400/10 filter blur-3xl animate-float-slow"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Main About Content */}
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 mb-24">
          <div className="flex-1 space-y-6 sm:space-y-8">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight text-[#1D4ED8]">
              About Portland
            </h2>

            <p className="text-gray-800 text-base sm:text-lg leading-relaxed animate-fadeInUp delay-100">
              At Drive With Portland, we do more than teach you to pass
              a test. We help you develop a lifelong driving skill. Our modern
              training approach and commitment to quality have made us one of
              Glasgow & Neighbourhoods most trusted driving schools. We employ
              experienced, DVSA-approved male and female instructors who tailor
              lessons to each learner's needs. They understand that everyone
              learns at their own pace and use their knowledge of local areas
              and test routes to support your progress. Learning to drive can
              feel daunting, but our instructors are here to build your
              confidence and ensure your safety.
            </p>
          </div>

          <div className="flex-1 relative w-full max-w-lg sm:max-w-xl lg:max-w-full animate-fadeInUp delay-400">
            <img
              src="/img/home_img-1.png"
              alt="About Illustration"
              className="w-full rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500"
            />
            <div className="absolute -top-8 -left-6 w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full animate-float-slow shadow-lg"></div>
            <div className="absolute -bottom-10 -right-8 w-20 h-20 sm:w-28 sm:h-28 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full animate-float-slow shadow-lg"></div>
            <div className="absolute top-1/3 left-1/4 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-yellow-400 to-amber-400 rounded-full animate-float-slow shadow-lg"></div>
          </div>
        </div>

        {/* Story Component */}
        <div className="w-full lg:w-4/5 mx-auto bg-white/60 shadow-lg rounded-lg py-8 lg:py-12 px-6 lg:px-20">
          <div className="flex flex-col items-center lg:flex-row lg:items-start lg:gap-10">
            {/* Story Shape (Circular Image) - Centered on mobile */}
            <div className="w-40 h-40 md:w-48 md:h-48 flex-shrink-0 rounded-full overflow-hidden mb-8 lg:mb-0 group cursor-pointer relative">
              <img
                src="/img/profile_pic.jpg"
                alt="Person on a tour"
                className="w-full h-full object-cover scale-110 transition-all duration-500 group-hover:scale-125 group-hover:blur-sm"
              />
              {/* Image Caption - Centered in image */}
              <div className="absolute inset-0 flex items-center justify-center bg-black/20 transition-all duration-500 opacity-0 group-hover:opacity-100">
                <div className="text-white text-xl font-bold tracking-wide px-2 text-center">
                  Sadaqat
                  <br /> Ahmed
                </div>
              </div>
            </div>

            {/* Story Text - Below image on mobile */}
            <div className="flex-1 sm:text-left lg:text-left">
              <h3 className="text-2xl lg:text-3xl mb-4 font-bold text-blue-700">
                Meet the Founder
              </h3>
              <p className="text-gray-800 text-base lg:text-lg leading-relaxed">
                I am a DVSA-qualified automatic driving instructor with over
                eight years of professional experience. I am proud to have
                received many five-star reviews from satisfied learners who
                value my calm, patient, and friendly teaching style. I tailor
                each lesson to suit individual needs, helping students build
                confidence, develop safe driving habits, and fully understand
                the road. My focus is not only on passing the driving test but
                also on creating responsible, confident drivers for life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
